import dayjs from 'dayjs';
import isBetweenPlugin from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

// Import any other plugins you might need
// import relativeTimePlugin from 'dayjs/plugin/relativeTime';
// import utcPlugin from 'dayjs/plugin/utc';

// Register all dayjs plugins
dayjs.extend(isBetweenPlugin);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(utc);
dayjs.extend(timezone);

// dayjs.extend(relativeTimePlugin);
